import { useCallback, useState } from 'react'
import useMount from 'react-use/lib/useMount'
import {
  buildAndroidIntentUrl,
  buildIosSafariUrl,
  detectTelegram,
  TelegramInfo,
} from 'utils/isTelegram'

const SSR_STATE: TelegramInfo = { isTelegram: false, os: 'other' }

const useIsTelegram = () => {
  const [info, setInfo] = useState<TelegramInfo>(SSR_STATE)
  const [copied, setCopied] = useState(false)

  useMount(() => {
    setInfo(detectTelegram())
  })

  const getCurrentUrl = useCallback(() => {
    if (typeof window === 'undefined') return ''
    return window.location.href
  }, [])

  const openInExternalBrowser = useCallback(() => {
    const url = getCurrentUrl()
    if (!url) return

    if (info.os === 'android') {
      window.location.href = buildAndroidIntentUrl(url)
    } else if (info.os === 'ios') {
      window.location.href = buildIosSafariUrl(url)
    }
  }, [getCurrentUrl, info.os])

  const copyLink = useCallback(async () => {
    const url = getCurrentUrl()
    if (!url) return

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = url
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }, [getCurrentUrl])

  return {
    isTelegram: info.isTelegram,
    os: info.os,
    copied,
    openInExternalBrowser,
    copyLink,
  }
}

export default useIsTelegram
